import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { NewStoryService } from '../../+stories/new/new.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Observable } from 'rxjs';
import * as sharedActions from '../../shared/shared.actions';
import { Store } from '@ngrx/store';
import * as fromApp from '../../app.reducer';
import { ContribService } from '../contrib/contrib.service';
import { LandingThemesSectionComponent } from 'app/+landing/landing/themes/themes.component';
import { UploadService } from './upload/upload.service';

@Component({
  selector: 'contribWizard',
  styleUrls: ['./contribWizard.component.scss'],
  templateUrl: './contribWizard.component.html',
})
export class ContribWizardComponent implements OnInit, OnDestroy {
  step = 1;
  totalSteps = 4;
  isOrderSubmitting: boolean;
  cancelUploadingConfirmationMessage;
  subscriptions = new Subscription();
  showConfirmLeavePage;
  redirectUrl;
  isMobile;
  owner;
  projectInfo;
  projectId: null | string;
  isProjectUpdating: null | boolean;
  invitationToken;

  constructor(
    private newStoryService: NewStoryService,
    private router: Router,
    private translate: TranslateService,
    private store: Store<fromApp.AppState>,
    private contribService: ContribService,
    private activatedRoute: ActivatedRoute,
    private uploadService: UploadService) {

  }

  @HostListener('window:beforeunload', ['$event'])
  preventCancelUpload($event) {
    this.preventLeave($event);
  }

  ngOnInit() {

    this.store.dispatch(new sharedActions.CurrentPage('wizardPage'));
    this.store.select('shared').subscribe(store => {
      this.isMobile = store.isMobile;
    });
    this.uploadService.initUploadStatus();
    this.contribService._owner.subscribe(response => {
      this.owner = response.owner;
      this.projectInfo = response.project;
      this.invitationToken = response.uuid;

      if (this.projectInfo === undefined) {
        this.router.navigate(['projects/' + this.activatedRoute.snapshot.paramMap.get('uuid') + '/contribute'],
        {queryParams: {token: this.activatedRoute.snapshot.queryParamMap.get('token')}});
      }
    });
  }

  preventLeave($event) {
    if (this.isOrderSubmitting) {
      $event.returnValue = this.cancelUploadingConfirmationMessage;
      return this.cancelUploadingConfirmationMessage;
    }
  }

  public nextStep() {
    window.scrollTo(0, 0);
    const nextStep = this.step + 1;
    this.step = nextStep;
  }

  public prevStep() {
    window.scrollTo(0, 0);
    const nextStep = this.step - 1;
    this.step = nextStep;
  }

  showLeavePageModal() {
    this.showConfirmLeavePage = true;
  }

  confirmLeavingPage() {
    this.newStoryService.cancelUploading(this.redirectUrl);
    this.showConfirmLeavePage = false;
  }

  stayOnPage() {
    this.redirectUrl = '';
    this.showConfirmLeavePage = false;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.store.dispatch(new sharedActions.CurrentPage(''));
  }


}
